/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { CommandMenuItemConfig } from '@veeam/components';

export const removeEdgeSeparator = (item: CommandMenuItemConfig, idx: number, items: CommandMenuItemConfig[]): boolean => {
    const { separator } = item;

    return !(separator && (idx === 0 || items.length - 1 === idx));
};
